import api from "../helper/request";

const createPayment = (obj) => api.post(`/player/create/custom`, obj);
const checkPayment = (obj) => api.get(`/qpay/invoice/check/${obj}`)

export {
    createPayment,
    checkPayment
}